import React from 'react';

const TransactionHistory = () => {
  return (
    <div className="card p-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
        Transaction History
      </h1>
      <p className="text-gray-600 dark:text-gray-400">
        Transaction history functionality will be implemented here.
      </p>
    </div>
  );
};

export default TransactionHistory;
